module.exports = __webpack_public_path__ + "static/media/cc-dev-senior.4c8021b4.png";